import * as v from 'valibot';

export const RewardCategorySchema = v.picklist([
  'airfare',
  'all',
  'bookstores',
  'business',
  'car rental',
  'charity',
  'dining',
  'discount',
  'drugstores',
  'entertainment',
  'gas',
  'groceries',
  'home improve',
  'hotel',
  'lodging',
  'movies',
  'office',
  'other',
  'parking',
  'playstation',
  'telecom',
  'travel',
  'utilities',
  'wireless',
]);

export const RecommendationCategorySchema = v.picklist([
  'ALL',
  'DRUG_STORES',
  'ENTERTAINMENT',
  'GAS',
  'GROCERIES',
  'HOME_IMPROVEMENT',
  'ONLINE_SHOPPING',
  'RESTAURANTS',
  'STREAMING',
  'TRAVEL',
]);

export const RewardSchema = v.object({
  category: RewardCategorySchema,
  isTiered: v.nullish(v.boolean()),
  period: v.nullish(v.string()),
  rate: v.pipe(v.number(), v.minValue(0)),
  recommendationCategory: v.nullish(RecommendationCategorySchema),
});

export const SignUpBonusTypeSchema = v.nullish(
  v.picklist(
    ['NO REWARDS', 'POINTS', 'CASH', 'MILES'],
    'signUpBonusType must be one of: NO REWARDS, POINTS, CASH, MILES',
  ),
);

export const PerkSchema = v.picklist([
  'has-companion-fare-annual-flight',
  'has-free-annual-hotel-night',
  'has-free-checked-bags',
  'has-airport-lounge-access',
  'has-globalentry-tsa-credit',
  'has-primary-rental-car-insurance',
  'has-travel-credits',
  'has-automatic-elite-status',
]);

export const CardUserSchema = v.picklist(['business', 'personal', 'student']);

export const CobrandHotelSchema = v.picklist([
  'BEST_WESTERN',
  'CHOICE',
  'HILTON',
  'HYATT',
  'IHG',
  'MARRIOTT',
  'OTHER',
  'RADISSON',
  'WYNDHAM',
]);

export const CobrandAirlineSchema = v.picklist([
  'AEROPLAN',
  'AIR_LINGUS',
  'ALASKA_AIRLINES',
  'AMERICAN_AIRLINES',
  'BRITISH_AIRWAYS',
  'DELTA',
  'IBERIA',
  'JETBLUE',
  'OTHER',
  'SOUTHWEST_AIRLINES',
  'UNITED_AIRLINES',
]);
